import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { get } from 'lodash';
import CollapsingTaxAndFees from './collapsing-tax-and-fees';
import { Spinner } from '../shared-components/decorators/spinner';

const AddOnsSummary = ({
  currency,
  addOnsTotal,
  addOnsTaxTotal,
  addOnsFeeTotal,
  taxesAndFees,
  taxesArray,
  feesArray,
  hostAddOnsSummary,
  isLoading
}) => {
  const subtotal = addOnsTotal - taxesAndFees;
  const hostAddOnsTotal = get(hostAddOnsSummary, 'amount');
  const hostAddOnsSubtotal = get(hostAddOnsSummary, 'primary_amount');

  if (isLoading) {
    return <Spinner additionalStyle='gray large' />;
  }

  return (
    <div className="summary-card">
      <h6>
        <FormattedMessage
          id='inbox.add_ons_summary.summary'
          defaultMessage='Summary'
        />
      </h6>
      <div className="flex space-between" data-testing-id="addons-subtotal">
        <div>
          <FormattedMessage
            id='inbox.add_ons_summary.subtotal'
            defaultMessage='Add-ons subtotal'
          />
        </div>
        <div>
          <FormattedNumber value={hostAddOnsSubtotal || subtotal} currency={currency} style={'currency'} />
        </div>
      </div>

      <CollapsingTaxAndFees
        addOnsTaxTotal={addOnsTaxTotal}
        addOnsFeeTotal={addOnsFeeTotal}
        taxesArray={taxesArray}
        feesArray={feesArray}
        currency={currency}
      />

      <hr className="dotted" />

      <div className="total flex space-between middle" data-testing-id="total">
        <h5>
          <FormattedMessage
            id='inbox.add_ons_summary.total'
            defaultMessage='Total'
          />
        </h5>
        <div>
          <FormattedNumber value={hostAddOnsTotal || addOnsTotal} currency={currency} style={'currency'} />
        </div>
      </div>
    </div>
  );
};

AddOnsSummary.propTypes = {
  currency: PropTypes.string,
  addOnsTotal: PropTypes.string,
  addOnsTaxTotal: PropTypes.string,
  addOnsFeeTotal: PropTypes.string,
  taxesAndFees: PropTypes.string,
  taxesArray: PropTypes.array,
  feesArray: PropTypes.array,
  isLoading: PropTypes.bool
};

export default AddOnsSummary;
